import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = process.env.REACT_APP_LOGO_URL;

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block group mb-4">
              <img 
                src={LOGO_URL} 
                alt="Pond Skape Logo" 
                className="h-12 w-auto transition-transform duration-300 group-hover:scale-105 brightness-0 invert"
              />
            </Link>
            <p className="text-sm leading-relaxed text-stone-400">
              Creating complete ecosystem water features for backyards and outdoor spaces—ponds, streams, and waterfalls that bring nature home.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-white mb-6">Navigate</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-stone-400 hover:text-white transition-colors duration-300">Home</Link>
              <Link to="/about" className="text-sm text-stone-400 hover:text-white transition-colors duration-300">About</Link>
              <Link to="/collaborate" className="text-sm text-stone-400 hover:text-white transition-colors duration-300">Collaborate</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-white mb-6">Connect</h4>
            <div className="flex flex-col gap-4">
              <a href="mailto:pondlife@gmail.com" className="flex items-center gap-3 text-sm text-stone-400 hover:text-white transition-colors">
                <Mail size={16} className="text-stone-500" />
                <span>pondlife@gmail.com</span>
              </a>
              <a href="tel:+918679032311" className="flex items-center gap-3 text-sm text-stone-400 hover:text-white transition-colors">
                <Phone size={16} className="text-stone-500" />
                <span>+91 86790 32311 (India)</span>
              </a>
              <a href="tel:+14088937953" className="flex items-center gap-3 text-sm text-stone-400 hover:text-white transition-colors">
                <Phone size={16} className="text-stone-500" />
                <span>+1 408 893 7953 (US)</span>
              </a>
              <div className="flex items-center gap-3 text-sm text-stone-400">
                <MapPin size={16} className="text-stone-500" />
                <span>India & United States</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-stone-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-stone-500">
              © {currentYear} Pond Skape. All rights reserved.
            </p>
            <p className="text-xs text-stone-500">
              Designed for the land, shaped by water.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
